import { readDeliveryTime } from '../providers/read-delivery-time';

export const shippingOptionFields = {
    deliveryTimeDisplay: {
        read: readDeliveryTime,
    },
};
